// src/Pages/AdminManagment/WaadDetails.jsx
import React, { useState } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { FaArrowLeft, FaUsers, FaUserFriends, FaSpinner, FaSearch, FaEye } from 'react-icons/fa';
import { useGetWaadUsersQuery } from '../../redux/services/sabAdminService/admin.Services'; 

export default function WaadDetails() {
    const { waadId } = useParams(); 
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type'); 

    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const { data, isLoading, error, refetch } = useGetWaadUsersQuery(
        { waadId, type, search: searchTerm, page: currentPage, limit: 20 },
        { skip: !waadId }
    );

    const users = data?.data || [];
    const total = data?.total || 0;
    const totalPages = data?.totalPages || 0;

    const handleSearch = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        refetch();
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <FaSpinner className="spinner-border text-primary" size={30} />
                <h5 className="mt-3">Loading Users...</h5>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-5">
                <div className="alert alert-danger">
                    <h5>Error Loading Data</h5>
                    <p>{error?.data?.message || error.message || 'Something went wrong'}</p>
                    <button className="btn btn-primary" onClick={refetch}>Retry</button>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* ===== HEADER ===== */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0">
                    <nav>
                        <h4 className="fw-semibold">
                            {type === 'pariwar' ? <><FaUsers className="me-2" /> कुल परिवार</> : <><FaUserFriends className="me-2" /> कुल सदस्य</>}
                            <span className="badge-custom bg-primary">{total}</span>
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/admin/admin-list">Admin List</Link></li>
                            <li className="breadcrumb-item active">Waad Details</li>
                        </ol>
                    </nav>
                </div>
                <div>
                    <Link to="/admin/admin-list" className="btn btn-outline-secondary">
                        <FaArrowLeft className="me-1" /> Back
                    </Link>
                </div>
            </div>

            {/* ===== SEARCH ===== */}
            <div className="card mb-4">
                <div className="card-body">
                    <form onSubmit={handleSearch} className="row g-3">
                        <div className="col-md-8">
                            <div className="input-group">
                                <span className="input-group-text"><FaSearch /></span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder={`Search ${type === 'pariwar' ? 'families' : 'members'} by name, mobile...`}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </div>
                        <div className="col-md-4 text-end">
                            <button type="button" className="btn btn-outline-secondary" onClick={() => { setSearchTerm(''); setCurrentPage(1); refetch(); }}>
                                Clear Filter
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* ===== TABLE ===== */}
            <div className="st-wrapper-card">
                {users.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="mb-3"><FaSearch className="text-muted" size={48} /></div>
                        <h5>No {type === 'pariwar' ? 'Families' : 'Members'} Found</h5>
                        <p className="text-muted">No records found for Waad ID: {waadId}</p>
                    </div>
                ) : (
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Father/Mother</th>
                                    <th>Mobile</th>
                                    <th>Gotra</th>
                                    <th>Village</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{(currentPage - 1) * 20 + index + 1}</td>
                                        <td className="fw-semibold">{item?.name || 'N/A'}</td>
                                        <td>
                                            {item.father_name || 'N/A'}
                                            <br /><small className="text-muted">{item.mother_name || ''}</small>
                                        </td>
                                        <td>{item?.mobile || 'N/A'}</td>
                                        <td>{item?.self_gotra || '-'}</td>
                                        <td>{item?.village_name || '-'}</td>
                                        <td>
                                            <span className={`badge ${item.status === "1" ? 'bg-success' : 'bg-danger'}`}>
                                                {item.status === "1" ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            {/* 🟢 Conditional Redirect Based on Roles */}
                                            {item.roles === 1 ? (
                                                <Link to={`/pariwar-view/${item.id}`} className="btn btn-sm btn-outline-primary">
                                                    <FaEye className="me-1" /> View Family
                                                </Link>
                                            ) : (
                                                <Link to={`/sadasya-view/${item.id}`} className="btn btn-sm btn-outline-primary">
                                                    <FaEye className="me-1" /> View Member
                                                </Link>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* ===== PAGINATION ===== */}
                {totalPages > 1 && (
                    <div className="d-flex flex-wrap align-items-center justify-content-between mt-4">
                        <div className="text-muted small mb-2 mb-md-0">
                            Showing {((currentPage - 1) * 20) + 1} to {Math.min(currentPage * 20, total)} of {total} entries
                        </div>
                        <nav>
                            <ul className="pagination mb-0">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                                </li>
                                {[...Array(Math.min(totalPages, 5))].map((_, idx) => {
                                    let pageNum;
                                    if (totalPages <= 5) pageNum = idx + 1;
                                    else if (currentPage <= 3) pageNum = idx + 1;
                                    else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + idx;
                                    else pageNum = currentPage - 2 + idx;
                                    return (
                                        <li key={pageNum} className={`page-item ${pageNum === currentPage ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => handlePageChange(pageNum)}>{pageNum}</button>
                                        </li>
                                    );
                                })}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </div>
        </div>
    );
}